<template>
  <div class="center-box-register">
    <!-- <div class="login-tit">大兴生物医药产业基地智慧化危险废物管理平台</div> -->
    <!-- <div class="login-tit">
      <span>欢迎登录</span>
    </div> -->
    <div class="register-header">
      <div class="register-title">忘记密码</div>
      <div class="link-login" @click="linkTo('login')">已有账号，立即登录</div>
    </div>
    <div class="forget-steps">
      <el-steps :active="forgetStep" process-status="wait" align-center>
        <el-step title="确认账号"></el-step>
        <el-step title="重置密码"></el-step>
        <el-step title="重置成功"></el-step>
      </el-steps>
    </div>
    <div class="center-box-main">
      <el-form :model="verifyForm" :rules="verifyRules" ref="verifyForm" class="verify-orm" v-show="forgetStep === 1">
        <el-form-item prop="mobile" class="login-item">
          <el-input placeholder="请输入手机号" :readonly="mobileReadonly" prefix-icon="el-icon-mobile"
            v-model="verifyForm.mobile"></el-input>
        </el-form-item>
        <el-form-item prop="verifycode" class="login-item">
          <el-input placeholder="请输入短信验证码" prefix-icon="el-icon-message" v-model="verifyForm.verifycode">
            <el-button type="text" slot="suffix" :disabled="countdown" @click="getVerifyCode">{{ buttonText }}</el-button>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button style="
              width: 100%;
              margin-top: 20px;
              background-color: red;
              letter-spacing: 12px;
              border-color: red;
            " type="primary" class="btn-ok" @click=" verifyMobileCode()">确定</el-button>
        </el-form-item>
      </el-form>

      <el-form ref="modifyForm" :model="modifyForm" v-show="forgetStep === 2" :rules="rules">
        <el-form-item prop="companyName" class="login-item add-login-item">
          <el-input placeholder="企业名称" disabled prefix-icon="el-icon-user" v-model="modifyForm.companyName"></el-input>
        </el-form-item>
        <el-form-item prop="uniformSocialCreditCode" class="login-item">
          <el-input disabled placeholder="统一社会信用代码" prefix-icon="el-icon-postcard"
            v-model="modifyForm.uniformSocialCreditCode"></el-input>
        </el-form-item>
        <el-form-item prop="password" class="login-item">
          <el-input placeholder="设置 6-18 位登录密码" prefix-icon="el-icon-lock" v-model="modifyForm.password"
            :show-password="true"></el-input>
        </el-form-item>
        <el-form-item prop="repeatPassword" class="login-item">
          <el-input placeholder="再次输入登录密码" v-model="modifyForm.repeatPassword" prefix-icon="el-icon-lock"
            :show-password="true"></el-input>
        </el-form-item>
        <el-button style="width: 100%; margin-top: 20px; background-color: red; border-color: red" type="primary"
          class="btn-ok" @click="modifyPwd()
            ">确认修改</el-button>
      </el-form>
      <div v-show="forgetStep === 3">
        <el-result icon="success" title="成功提示" subTitle="请根据提示进行操作">
          <template slot="extra">
            <el-button type="primary" size="medium" @click="linkTo('login')">返回</el-button>
          </template>
        </el-result>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "forgetPwd",
  data() {
    let repeatValidate = (rule, value, callback) => {
      if (value != this.modifyForm.password) {
        callback(new Error("两次密码输入不一致"));
      } else if (/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9a-zA-Z\x21-\x7e]{6,18}$/.test(value)) {
        callback();
      } else {
        callback(new Error("请输入包含英文字母大小写、数字和特殊符号的 6-18 位组合"));
      }
    };
    return {
      mobileReadonly: false,
      countdown: false, // 表示按钮是否处于倒计时状态
      timeLeft: 60, // 表示剩余时间
      verifyForm: {
        mobile: "",
        verifycode: "",
      },
      modifyForm: {
        companyName: "",
        uniformSocialCreditCode: "",
        password: "",
        repeatPassword: "",
      },
      forgetStep: 1,
      rememberPwd: false,

      verifyRules: {
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号格式有误",
            trigger: "blur",
          },
        ],
        verifycode: [{
          required: true,
          message: "请输入短信验证码",
          trigger: "blur",
        }],
      },
      rules: {
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            pattern: /^(?![A-z0-9]+$)(?=.[^%&',;=?$\x22])(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{6,20}$/,
            message: "密码长度为6~20位，必须包含大小写字母、符号、数字。",
            trigger: "blur",
          },
        ],
        repeatPassword: [
          { required: true, message: "请再输入一遍密码", trigger: "blur" },
          { validator: repeatValidate, trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    buttonText() {
      return this.countdown ? `${this.timeLeft}` : "获取验证码";
    },
  },
  methods: {
    linkTo(page) {
      this.$emit("linkTo", page);
    },
    modifyPwd() {

      this.$refs.modifyForm.validate((valid) => {

        if (valid) {
          const url = this.$api.appUsers.forgetPwd;
          // forgetPwdVerify,forgetPwd
          const postData = {
            ...this.verifyForm,
            password: this.modifyForm.password
          }
          const parames = this.$qs.stringify(postData)
          this.$axios
            .post(url, parames, false)
            .then((res) => {
              if (res.data.code === 0) {

                this.forgetStep = 3;

              } else {
                this.$message({
                  type: "error",
                  message: res.data.msg,
                });
              }
            })
            .catch((err) => {
              console.log("失败");
            });

        } else {
          console.log("error submit!!");
          return false;
        }
      });

    },

    verifyMobileCode() {

      this.$refs.verifyForm.validate((valid) => {

        if (valid) {
          const url = this.$api.appUsers.forgetPwdVerify;
          // forgetPwdVerify,forgetPwd
          const parames = this.verifyForm;
          this.$axios
            .get(url, parames, false)
            .then((res) => {
              if (res.data.code === 0) {
                const { name, uniformSocialCreditCode } = res.data.data;
                this.modifyForm.companyName = name;
                this.modifyForm.uniformSocialCreditCode = uniformSocialCreditCode;

                this.forgetStep = 2;

              } else {
                this.$message({
                  type: "error",
                  message: res.data.msg,
                });
              }
            })
            .catch((err) => {
              console.log("失败");
            });

        } else {
          console.log("error submit!!");
          return false;
        }
      });

    },

    getVerifyCode() {
      this.$refs.verifyForm.validateField(['mobile'], (valid) => {

        if (!valid) {
          const url = this.$api.appUsers.forgetPwdSms;
          // forgetPwdVerify,forgetPwd
          const parames = {
            mobile: this.verifyForm.mobile
          };
          this.$axios
            .get(url, parames, false)
            .then((res) => {
              if (res.data.code === 0) {
                this.mobileReadonly = true;
                this.countdown = true;
                let timeInterval = setInterval(() => {
                  this.timeLeft--;
                  if (this.timeLeft === 0) {
                    clearInterval(timeInterval);
                    this.countdown = false;
                    this.timeLeft = 60;
                  }
                }, 1000);

              } else {
                this.$message({
                  type: "error",
                  message: res.data.msg,
                });
              }
            })
            .catch((err) => {
              console.log("失败");
            });

        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.center-box-register {
  width: 550px;
  height: 560px;
  background: #ffffff;
  background-size: 100% 100%;
  text-align: center;
  margin: auto;
  border-radius: 2px;

  .register-header {
    display: flex;
    justify-content: space-between;

    .register-title {
      text-align: left;
      padding-top: 20px;
      padding-left: 50px;
      font-size: 18px;
      font-weight: 800;
    }

    .link-login {
      cursor: pointer;
      padding: 30px 50px 0px 0px;
      color: #409eff;
      font-size: 12px;
      font-weight: bold;
    }
  }

  .verify-orm {
    margin-top: 60px;
  }

  .forget-steps {
    margin: 20px 0px;

    /deep/.el-step__title {
      font-size: 12px;
      line-height: 30px;
    }

    /deep/.el-step__icon {
      font-size: 12px;
    }
  }

  .center-box-main {
    padding: 10px 100px;
  }
}
</style>
